export default function PrivacyPage() {
	return (
		<div className="container mx-auto max-w-3xl px-4 py-16">
			<h1 className="mb-8 text-3xl font-bold text-slate-900">
				Politique de confidentialité
			</h1>
			<p className="mb-6 text-sm text-slate-500">
				Dernière mise à jour : 3 mars 2026
			</p>

			<div className="prose prose-slate max-w-none">
				<h2>1. Introduction</h2>
				<p>
					Vigilio, exploité par Themelio Inc. (« nous », « notre »,
					« nos »), s'engage à protéger la vie privée des
					utilisateurs de sa plateforme de veille médiatique (le
					« Service »). La présente politique décrit comment nous
					recueillons, utilisons et protégeons vos renseignements
					personnels conformément à la{' '}
					<em>
						Loi sur la protection des renseignements personnels
						dans le secteur privé
					</em>{' '}
					du Québec (Loi 25) et à la{' '}
					<em>
						Loi sur la protection des renseignements personnels et
						les documents électroniques
					</em>{' '}
					(LPRPDE) du Canada.
				</p>

				<h2>2. Renseignements recueillis</h2>
				<h3>2.1 Renseignements fournis directement</h3>
				<ul>
					<li>
						Nom, adresse courriel, nom d'utilisateur lors de
						l'inscription
					</li>
					<li>
						Nom de l'organisation, secteur d'activité, taille de
						l'équipe
					</li>
					<li>Préférences de notification et fuseau horaire</li>
				</ul>

				<h3>2.2 Renseignements recueillis automatiquement</h3>
				<ul>
					<li>
						Adresse IP, type de navigateur, pages consultées
						(journaux serveur)
					</li>
					<li>
						Données de session (cookie de session httpOnly,
						nécessaire au fonctionnement)
					</li>
					<li>
						Données de diagnostic et de performance (Sentry), avec
						votre consentement
					</li>
				</ul>

				<h2>3. Utilisation des renseignements</h2>
				<p>Nous utilisons vos renseignements pour :</p>
				<ul>
					<li>Fournir et maintenir le Service</li>
					<li>Gérer votre compte et votre organisation</li>
					<li>
						Envoyer des alertes médiatiques et courriels de
						distribution
					</li>
					<li>Améliorer le Service (analyses agrégées)</li>
					<li>
						Respecter nos obligations légales et réglementaires
					</li>
				</ul>

				<h2>4. Partage des renseignements</h2>
				<p>
					Nous ne vendons pas vos renseignements personnels. Nous
					pouvons les partager avec :
				</p>
				<ul>
					<li>
						<strong>Fournisseurs de services</strong> : Fly.io
						(hébergement), Resend (courriels), Sentry
						(diagnostic) — liés par des ententes de
						confidentialité
					</li>
					<li>
						<strong>Autorités légales</strong> : lorsque requis
						par la loi
					</li>
				</ul>

				<h2>5. Conservation des données</h2>
				<p>
					Vos renseignements sont conservés tant que votre compte
					est actif. Les articles agrégés sont conservés selon
					votre plan d'abonnement. Vous pouvez supprimer votre
					compte et toutes les données associées à tout moment dans
					vos paramètres.
				</p>

				<h2>6. Sécurité</h2>
				<p>
					Nous mettons en œuvre des mesures de sécurité
					appropriées : chiffrement en transit (HTTPS), mots de
					passe hachés (bcrypt), sessions sécurisées, et contrôle
					d'accès multi-tenant.
				</p>

				<h2>7. Vos droits</h2>
				<p>Conformément à la Loi 25, vous avez le droit de :</p>
				<ul>
					<li>Accéder à vos renseignements personnels</li>
					<li>Rectifier des renseignements inexacts</li>
					<li>Supprimer vos renseignements</li>
					<li>
						Télécharger une copie de vos données (portabilité)
					</li>
					<li>Retirer votre consentement aux cookies analytiques</li>
				</ul>
				<p>
					Pour exercer ces droits, contactez-nous à{' '}
					<a href="mailto:privacy@themelio.ca">
						privacy@themelio.ca
					</a>
					.
				</p>

				<h2>8. Modifications</h2>
				<p>
					Nous pouvons modifier cette politique. Les modifications
					importantes seront communiquées par courriel ou
					notification dans le Service.
				</p>

				<h2>9. Contact</h2>
				<p>
					Pour toute question concernant cette politique :<br />
					Themelio Inc.
					<br />
					<a href="mailto:privacy@themelio.ca">
						privacy@themelio.ca
					</a>
				</p>
			</div>
		</div>
	)
}
